/**
 * Timeouts shared by every provider's session frame. The end and score flows
 * hit the same edge functions regardless of provider, so the budgets belong in
 * one place rather than being re-declared per frame.
 */

/** Ending a session (persist transcript, close vendor session). */
export const END_FLOW_TIMEOUT_MS = 45_000;
/** Scoring a finished session (LLM round-trip included). */
export const SCORE_FLOW_TIMEOUT_MS = 130_000;

/** Reject with `message` when `promise` has not settled within `ms`. */
export function withTimeout<T>(promise: Promise<T>, ms: number, message: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = window.setTimeout(() => reject(new Error(message)), ms);
    promise
      .then(resolve)
      .catch(reject)
      .finally(() => window.clearTimeout(timer));
  });
}
